import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StringToIdPipeModule } from '@shared/ui/pipes/string-to-id/string-to-id.module';

import { JBPageHeaderModule } from '../../shared/temp-jb-page-header';
import { LinksModule } from '../../shared/ui/links';
import {
  PageHeaderContainerComponent,
  pageHeaderContainerResolver,
} from './page-header-container.component';

const MODULES = [
  CommonModule,
  JBPageHeaderModule,
  LinksModule,
  StringToIdPipeModule,
];

const DECLARATIONS = [PageHeaderContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class PageHeaderContainerModule {
  static entry = PageHeaderContainerComponent;
  static componentDataResolver = pageHeaderContainerResolver;
}
